import { FC } from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useIntl } from 'react-intl';
import {
	AccountCircleOutlined,
	LogoutOutlined,
	AccountBalanceWalletOutlined,
	HelpOutlineOutlined,
	SchoolOutlined,
	ExitToAppOutlined,
} from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { To } from 'history';
import { useCookies } from 'react-cookie';

type Props = Readonly<{
	handleLogout: () => void;
	onClose: () => void;
}>;

const INFO_MAIL = 'info@outofdark.com';
const OOD_GUIDE_URL = 'https://guide.outofdark.com/';

const ProfileLinksList: FC<Props> = ({ handleLogout, onClose }) => {
	const intl = useIntl();
	const navigate = useNavigate();

	const [{ ood_impersonated_token }] = useCookies(['ood_impersonated_token']);

	const linkClickHandler = (toUrl: To) => {
		navigate(toUrl);
		onClose();
	};

	return (
		<List component={'nav'} sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
			<ListItemButton onClick={() => linkClickHandler('/settings/my-account')}>
				<ListItemIcon>
					<AccountCircleOutlined />
				</ListItemIcon>
				<ListItemText primary={intl.formatMessage({ id: 'profile.account' })} />
			</ListItemButton>
			<ListItemButton onClick={() => linkClickHandler('/settings/organization/billing')}>
				<ListItemIcon>
					<AccountBalanceWalletOutlined />
				</ListItemIcon>
				<ListItemText primary={intl.formatMessage({ id: 'profile.billing' })} />
			</ListItemButton>

			<ListItemButton href={`mailto:${INFO_MAIL}`} target={'_blank'}>
				<ListItemIcon>
					<HelpOutlineOutlined />
				</ListItemIcon>
				<ListItemText primary={intl.formatMessage({ id: 'profile.support-and-feedback' })} />
			</ListItemButton>

			<ListItemButton href={OOD_GUIDE_URL} target={'_blank'}>
				<ListItemIcon>
					<SchoolOutlined />
				</ListItemIcon>
				<ListItemText primary={intl.formatMessage({ id: 'profile.knowledge-base' })} />
			</ListItemButton>

			<ListItemButton onClick={handleLogout}>
				{ood_impersonated_token != null ? (
					<>
						<ListItemIcon>
							<ExitToAppOutlined />
						</ListItemIcon>
						<ListItemText primary={intl.formatMessage({ id: 'profile.end-impersonation' })} />
					</>
				) : (
					<>
						<ListItemIcon>
							<LogoutOutlined />
						</ListItemIcon>
						<ListItemText primary={intl.formatMessage({ id: 'profile.logout' })} />
					</>
				)}
			</ListItemButton>
		</List>
	);
};

export default ProfileLinksList;
